<template>
  <v-container>
    <!-- <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="Search"
          class="mx-4"
        ></v-text-field>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn color="blue darken-1" small @click="editItem(item)">Edit</v-btn>
        <v-btn color="red darken-1" small @click="deleteItem(item)">Delete</v-btn>
      </template>
    </v-data-table> -->
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Role", value: "role" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      users: [
        { name: "Alice", email: "alice@example.com", role: "Admin" },
        { name: "Bob", email: "bob@example.com", role: "User" },
        { name: "Charlie", email: "charlie@example.com", role: "Editor" },
      ],
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  methods: {
    editItem(item) {
      console.log("Edit", item);
    },
    deleteItem(item) {
      console.log("Delete", item);
    },
  },
  created() {
    // "RESPONSE_MESSAGE": "Мэдээлэл хоосон",

    var urlLink =
      this.$store.state.domainESISAddress +
      "/svc/api/hub/group/certificate/info/" +
      this.$attrs.selectedClassGroup.STUDENT_GROUP_ID;
    console.log("urlLink", urlLink);
    console.log(this.$attrs.tokenData.token);
    axios
      .post(
        "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
        {
          url: urlLink,
          token: this.$attrs.tokenData.token,
        }
      )
      .then((res) => {
        console.log(res.data.SUCCESS_CODE, res.data.RESULT, res);
        if (res && res.data && res.data.SUCCESS_CODE == 200) {
          this.$swal.fire(
            "Амжилттай",
            "Шалгалтын хуваарь амжилттай татагдлаа",
            "success"
          );
        } else if (res && res.data && res.data.SUCCESS_CODE == 203) {
          this.$swal.fire(
            res.data.RESPONSE_MESSAGE,
            "error"
          );
        }
      });
  },
};
</script>
